import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';

const ClassEnrollmentConfirmModal = ({
  show,
  studentName,
  action,
  onConfirm,
  onCancel,
}) => {
  const isAdd = action === 'add';
  const title = isAdd ? 'Dodać do klasy?' : 'Usunąć z klasy?';
  const message = isAdd
    ? `Czy dodać ${studentName} również do stałej listy klasy?`
    : `Czy usunąć ${studentName} również ze stałej listy klasy?`;
  const confirmText = isAdd ? 'Tak, dodaj do klasy' : 'Tak, usuń z klasy';
  const cancelText = 'Nie, tylko te zajęcia';

  return (
    <Modal show={show} onHide={onCancel} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel}>
          {cancelText}
        </Button>
        <Button variant="primary" onClick={onConfirm}>
          {confirmText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

ClassEnrollmentConfirmModal.propTypes = {
  show: PropTypes.bool.isRequired,
  studentName: PropTypes.string.isRequired,
  action: PropTypes.oneOf(['add', 'remove']).isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default ClassEnrollmentConfirmModal;